// extracted by mini-css-extract-plugin
export default {"container":"SearchInput_container__TuAZn","input":"SearchInput_input__sVTAL"};